import Loader from '../components/MapLoader/Loader';

class LoaderManager {
	constructor() {
		this.container = document.getElementById('appContainer');
		this.loader = null;

		// helps to deal with loaders render if loading already in progress
		this.loadings = 0;
	}

	mountLoader(message) {

		if (this.loadings++ > 0 && this.loader) {
			this.loader.updateMessage(message);
			return;
		}

		this.loader = new Loader({message});
		this.loader.mount(this.container);
	}

	unmountLoader() {
		if (--this.loadings > 0) return;

		this.loader.unmount();
		this.loader = null;
	}

	updateLoaderMessage(message) {
		this.loader && this.loader.updateMessage(message);
	}
}

export default new LoaderManager();